import { ClientLogin, storeMfaHash, storeRememberMfa } from 'vopay';
import { useState, useEffect } from 'react';
import TwoFactorAuthenticationQRCode from './TwoFactorAuthenticationQRCode/TwoFactorAuthenticationQRCode';
import TwoFactorAuthenticationInfo from './TwoFactorAuthenticationInfo/TwoFactorAuthenticationInfo';
import TwoFactorAuthenticationPin, { PinFormFeilds } from './TwoFactorAuthenticationPin/TwoFactorAuthenticationPin';
import usePostPortalGenerateQRCode from '../../../hooks/useApi/usePostPortalGenerateQRCode';
import usePostPortalAuthenticate from '../../../hooks/useApi/usePostPortalAuthenticate';
import { useClientLogin } from '../../../providers/ClientLogin.provider';
import { useTranslation } from 'react-i18next';

type TwoFactorAuthenticationContainerProps = {
  handleContinue: () => void;
  handleCancel: () => void;
  loginRequest: ClientLogin;
  loginUserName: string;
};

enum TwoFactorAuthenticationState {
  PinCode,
  QRCode,
  TwoFactorInfomation,
}
const TwoFactorAuthenticationContainer = ({
  handleContinue,
  handleCancel,
  loginRequest,
  loginUserName,
}: TwoFactorAuthenticationContainerProps) => {
  const { response } = useClientLogin();
  const [twoFactorAuthenticationState, setTwoFactorAuthenticationState] = useState<TwoFactorAuthenticationState>(
    response.MFAEnabled ? TwoFactorAuthenticationState.PinCode : TwoFactorAuthenticationState.TwoFactorInfomation,
  );

  const [postPortalGenerateQRCodeResponse, postPortalGenerateQRCode] = usePostPortalGenerateQRCode({});
  const [, , , authenticateQRCode] = usePostPortalAuthenticate({});
  const [pinErrorMsg, setPinErrorMsg] = useState('');
  const [pinError, setPinErorr] = useState(false);
  const { t } = useTranslation('translations', { keyPrefix: 'Login.MFA' });

  useEffect(() => {
    if (postPortalGenerateQRCodeResponse) {
      setTwoFactorAuthenticationState(TwoFactorAuthenticationState.QRCode);
    }
  }, [postPortalGenerateQRCodeResponse]);

  const handlers = {
    continueTwoFactorInformation: () => {
      postPortalGenerateQRCode({
        Username: loginRequest.Username || '',
        PortalDomain: import.meta.env.VITE_DOMAIN,
      });
    },
    continueQRCode: () => {
      setTwoFactorAuthenticationState(TwoFactorAuthenticationState.PinCode);
    },
  };

  async function submitPin(values: PinFormFeilds) {
    const res = await authenticateQRCode({
      Code: values.Code,
      Username: loginRequest.Username || '',
    });

    if (res.Success && res.Authorized && res.MfaHash) {
      storeMfaHash(loginUserName, res.MfaHash);

      if (values.rememberDevice) {
        storeRememberMfa(loginUserName);
      }

      handleContinue();
    } else {
      setPinErorr(true);

      if (res.Success) {
        setPinErrorMsg(t('invalidCodeValidation'));
      } else {
        setPinErrorMsg(res.ErrorMessage);
      }
    }
  }

  return (
    <>
      {twoFactorAuthenticationState === TwoFactorAuthenticationState.TwoFactorInfomation && (
        <TwoFactorAuthenticationInfo handleContinue={handlers.continueTwoFactorInformation} />
      )}
      {twoFactorAuthenticationState === TwoFactorAuthenticationState.QRCode && (
        <TwoFactorAuthenticationQRCode
          QRCode={postPortalGenerateQRCodeResponse?.QRCode || ''}
          handleContinue={handlers.continueQRCode}
        />
      )}
      {twoFactorAuthenticationState === TwoFactorAuthenticationState.PinCode && (
        <TwoFactorAuthenticationPin
          handleCancel={handleCancel}
          handleFormSubmit={submitPin}
          initialValues={{ Code: '', rememberDevice: false }}
          hasError={pinError}
          errorMsg={pinErrorMsg}
        />
      )}
    </>
  );
};
export default TwoFactorAuthenticationContainer;
